import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { getOtherExpenseInput, OtherExpensesModel } from './model';

export function useGetOtherExpenseDetail(
  input?: getOtherExpenseInput,
  options?: UseQueryOptions<ApiResult<OtherExpensesModel>, ApiError>,
): UseQueryResult<ApiResult<OtherExpensesModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getOtherExpenses', input?.id],
      () =>
        QueryFetchFunction({
          url: `other-expenses/${input?.id}`,
        }),
      options,
    ),
    OtherExpensesModel,
  );
}

export function getOtherExpenseKey(input?: getOtherExpenseInput) {
  return ['getOtherExpenses', input?.id];
}
